import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { disposeOnUnmount, Observe, watch } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import InfoPanel, { IInfoPanelProps } from '../ui/InfoPanel';
import InfoPanelHeader from '../ui/InfoPanelHeader';
import Loader from '../ui/Loader';
import { withStyles } from '../utility/styles';
import InfoPanelTimeOffRequestView from './InfoPanelTimeOffRequestView';
import infoPanelTimeOffRequestViewModel from './InfoPanelTimeOffRequestViewModel';
import timeOffInfoPanelModel from './TimeOffInfoPanelModel';

const styles = (_theme: Theme) => ({
  root: {},
  defaultMessage: {
    fontStyle: 'italic',
  },
});

interface ITimeOffInfoPanelProps {
  classes?: any;
  InfoPanelProps?: IInfoPanelProps;
}

type TimeOffInfoPanelProps = WithStyle<ReturnType<typeof styles>, ITimeOffInfoPanelProps>;

class TimeOffInfoPanel extends React.Component<TimeOffInfoPanelProps> {
  static defaultProps = {
    InfoPanelProps: {
      defaultSize: {
        width: 540,
        height: '100%',
      },
      minWidth: 540,
    },
  };

  constructor(props: TimeOffInfoPanelProps) {
    super(props);

    timeOffInfoPanelModel.load();
  }

  componentWillUnmount() {
    timeOffInfoPanelModel.deactivate();
    timeOffInfoPanelModel.reset();
  }

  // biome-ignore lint/correctness/noNestedComponentDefinitions: <explanation>
  UNSAFE_componentWillUpdate(_nextProps: ITimeOffInfoPanelProps) {
    timeOffInfoPanelModel.load();
  }

  componentDidMount() {
    disposeOnUnmount(this, () => {
      watch(
        () => timeOffInfoPanelModel.selectedCell,
        () => {
          this.forceUpdate();
        },
      );
    });
  }

  render() {
    const { classes, InfoPanelProps } = this.props;

    return (
      <InfoPanel {...InfoPanelProps} classes={{ infoPanelRoot: classes.root }}>
        <Observe
          render={() => (
            <Loader loading={timeOffInfoPanelModel.isLoading}>
              <Observe
                render={() => {
                  switch (timeOffInfoPanelModel.selectedCellType) {
                    case 'Employee':
                    case 'Job': {
                      const hasCompatibleTimeOffRequests = !!timeOffInfoPanelModel.loadValue;
                      return hasCompatibleTimeOffRequests ? (
                        <InfoPanelTimeOffRequestView model={infoPanelTimeOffRequestViewModel} />
                      ) : (
                        <InfoPanelHeader
                          title={
                            <Typography className={classes.defaultMessage}>
                              The time off request pane is unavailable for the current selection. Either the employee has no time
                              off requests for this date range, or the employee has more than one time off request for this date
                              range, and each one needs to be selected directly
                            </Typography>
                          }
                        />
                      );
                    }

                    case 'Date':
                    case 'ListViewCell':
                      return <InfoPanelTimeOffRequestView model={infoPanelTimeOffRequestViewModel} />;

                    default:
                      if (infoPanelTimeOffRequestViewModel.isNew) {
                        return <InfoPanelTimeOffRequestView model={infoPanelTimeOffRequestViewModel} />;
                      } else {
                        return (
                          <InfoPanelHeader
                            title={
                              <Typography className={classes.defaultMessage}>
                                Selecting a cell displays the time off request, if able
                              </Typography>
                            }
                          />
                        );
                      }
                  }
                }}
              />
            </Loader>
          )}
        />
      </InfoPanel>
    );
  }
}

export default withStyles<ITimeOffInfoPanelProps>(styles, TimeOffInfoPanel);
